import {
	Button,
	Card,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	Snackbar,
	TextField,
	Typography,
} from "@material-ui/core/";
import CircularProgress from "@material-ui/core/CircularProgress";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AlertNotistack from "../../components/molecules/AlertNotistack";
import AuthContext from "../../context/Auth/authContext";

const useStyles = makeStyles((theme) => ({
	root: {
		height: "100vh",
		overflow: "visible",
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
	},
	rootLogo: {
		width: "100%",
		display: "flex",
		justifyContent: "flex-end",
	},
	cardRoot: {
		padding: theme.spacing(4),
		background: theme.palette.background.default,
		// backgroundColor: 'green',
		width: "70%",
		overflow: "visible",
	},
	progress: {
		color: "white",
	},
	image: {
		background: `linear-gradient(left,#316B83,#6D8299)`,
	},
	paper: {
		height: "100%",
		margin: theme.spacing(0, 4),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	avatar: {
		margin: theme.spacing(1),
	},
	form: {
		width: "100%",
		backgroundColor: "red",
	},
	formDiv: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		marginBottom: "3rem",
	},
	formImage: {
		display: "flex",
		justifyContent: "center",
	},
	formTitle: {
		textAlign: "center",
		fontSize: "20px",
		fontWeight: "bold",
		display: "none",
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		width: "100%",
		background: `linear-gradient(left,#316B83,#6D8299)`,
		color: "white",
		"&:hover": {
			background: `#677da1`,
		},
	},
	quote: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	quoteText: {
		color: theme.palette.common.white,
		fontWeight: 300,
		textAlign: "center",
	},
	error: {
		backgroundColor: theme.palette.text.primary,
	},
	OutlineInput: {
		// minWidth: 500,
		width: "100%",
		minHeight: "4rem",
	},
	margin: {
		margin: theme.spacing(1),
	},
	textField: {
		width: "25ch",
	},
	text: {
		textAlign: "center",
	},
	"@media (max-width: 640px)": {
		cardRoot: {
			width: "100%",
		},
	},
	"@media (max-width: 768px)": {
		image: {
			display: "none",
		},
		text: {
			fontSize: "14px",
		},
		formTitle: {
			display: "block",
		},
	},
	[theme.breakpoints.only("md")]: {
		formDiv: {
			display: "none",
		},
	},
}));

export default function SignIn(props) {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const { register, handleSubmit, errors } = useForm();

	const [values, setValues] = useState({
		showPassword: false,
	});

	const authContext = useContext(AuthContext);
	const {
		login,
		token,
		open,
		vertical,
		horizontal,
		error,
		clearFailed,
		loadLogoImages,
		stateLogoImages,
	} = authContext;

	const [state, setState] = useState({
		initialState: {
			loading: false,
		},
	});

	const handleClickShowPassword = (event) => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const { loading } = state;

	useEffect(() => {
		if (error) {
			if (error === "Network Error") {
				enqueueSnackbar("Server Offline", AlertNotistack("error"));
			} else if (error === "Request failed with status code 400") {
				enqueueSnackbar(
					"Request failed with status code 400",
					AlertNotistack("error")
				);
			} else if (error.token === undefined || error.token === "") {
				enqueueSnackbar(error, AlertNotistack("error"));
			} else {
				enqueueSnackbar(error, AlertNotistack("error"));
			}
			clearFailed();
			setState({ ...state });
		}
		loadLogoImages();

		//eslint-disable-next-line
	}, [error, token, props.history]);

	const onSubmit = (data) => {
		const { username, password } = data;
		login({ username, password });
	};

	return (
		<Grid container component="main" className={classes.root}>
			<CssBaseline />
			<Grid item xs={12} sm={12} md={12} lg={6} className={classes.image}>
				<div className={classes.quote}>
					{stateLogoImages ? (
						<img
							src={stateLogoImages?.path_banner}
							alt={stateLogoImages?.nama_aplikasi}
						/>
					) : (
						<CircularProgress color="inherit" />
					)}

					<Typography variant="h2" className={classes.quoteText}>
						<b
							style={{ color: stateLogoImages?.nama_aplikasi ? "#fff" : "red" }}
						>
							{stateLogoImages?.nama_aplikasi}
						</b>
					</Typography>
				</div>
			</Grid>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={6}
				elevation={6}
				className={classes.gridForm}
			>
				<div className={classes.paper}>
					<Card className={classes.cardRoot}>
						<div className={classes.formDiv}>
							<div>
								<div className={classes.formImage}>
									{stateLogoImages ? (
										<img
											src={stateLogoImages?.path_logo}
											height="70"
											alt="logo-ticketing"
										/>
									) : (
										<CircularProgress color="inherit" />
									)}
								</div>
								<p className={classes.formTitle}>
									{stateLogoImages?.nama_aplikasi}
								</p>
							</div>
						</div>
						<form onSubmit={handleSubmit(onSubmit)}>
							{open && (
								<Snackbar
									anchorOrigin={{ vertical, horizontal }}
									key={`${vertical},${horizontal}`}
									open={open}
									ContentProps={{
										"aria-describedby": "message-id",
									}}
									message={<span id="message-id">User Not found</span>}
								/>
							)}
							<FormControl
								className={clsx(classes.textField)}
								style={{ display: "flex", marginBottom: "1rem", width: "100%" }}
							>
								<TextField
									id="username"
									name="username"
									placeholder="Username"
									label="Username"
									type="string"
									color="secondary"
									error={errors.username}
									variant="outlined"
									inputRef={register({
										required: {
											value: true,
											message: "Username tidak boleh kosong",
										},
										pattern: {
											value: /^[a-zA-Z0-9]{1,20}$/,
											message: "Username without Special Character",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.username && errors.username.message}
									labelWidth={70}
								/>
							</FormControl>
							<FormControl
								className={clsx(classes.textField)}
								style={{ width: "100%" }}
								variant="outlined"
							>
								<InputLabel
									htmlFor="outlined-adornment-password"
									error={errors.password}
									color="secondary"
								>
									Password
								</InputLabel>
								<OutlinedInput
									id="password"
									name="password"
									placeholder="Password"
									label="Password"
									color="secondary"
									type={values.showPassword ? "text" : "password"}
									error={errors.password}
									InputLabelProps={{ shrink: true }}
									inputRef={register({
										required: {
											value: true,
											message: "Password tidak boleh kosong",
										},
									})}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
											>
												{values.showPassword ? (
													<Visibility />
												) : (
													<VisibilityOff />
												)}
											</IconButton>
										</InputAdornment>
									}
									labelWidth={70}
								/>
								{errors.password && (
									<Typography variant="caption" color="error">
										{errors.password.message}
									</Typography>
								)}
							</FormControl>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								className={classes.submit}
							>
								{loading ? (
									<CircularProgress size={24} className={classes.progress} />
								) : (
									<div>SIGN IN</div>
								)}
							</Button>
							<Typography
								color="textSecondary"
								justifyContent="center"
								className={classes.text}
							>
								Please Contact Admin to Have an Account
							</Typography>
						</form>
					</Card>
				</div>
			</Grid>
		</Grid>
	);
}
